import { render, staticRenderFns } from "./DropdownLink.vue?vue&type=template&id=28b7e0eb&scoped=true&"
import script from "./DropdownLink.vue?vue&type=script&lang=js&"
export * from "./DropdownLink.vue?vue&type=script&lang=js&"
import style0 from "./DropdownLink.vue?vue&type=style&index=0&id=28b7e0eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b7e0eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/induline.salamander.live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28b7e0eb')) {
      api.createRecord('28b7e0eb', component.options)
    } else {
      api.reload('28b7e0eb', component.options)
    }
    module.hot.accept("./DropdownLink.vue?vue&type=template&id=28b7e0eb&scoped=true&", function () {
      api.rerender('28b7e0eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ui/DropdownLink.vue"
export default component.exports